import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ProductTypeBasicInfoComponent = ({ onInnerBasicFormChange, selectedProductTypes }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedProductTypes?.Name}
                />

                <InputContainer
                    label="Type"
                    name="Type"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Type'

                        )
                    }}
                    type="text"
                    value={selectedProductTypes?.Type}
                />
                <InputContainer
                    label="CargoOrder"
                    labelField="IsCargoOrder"
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsCargoOrder'
                        );
                    }}
                    type="checkbox"
                    value={selectedProductTypes?.IsCargoOrder}
                />

            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default ProductTypeBasicInfoComponent;
